import React, { useRef, useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DatePicker,
  Collapse,
  Select,
  Button,
  Radio,
  Table,
  Modal,
  Form,
  Input,
  Drawer,
  Checkbox
} from "antd";
import BidPreview from "./BidPreview";
import styles from "./styles.module.css";
import { BreathAPIs } from "../../APIs/BreathAPIs";
import { toast } from "react-toastify";
import InvoiceView from "./InvoiceView";
import { Label } from "recharts";
import Title from "antd/es/skeleton/Title";
import dayjs from "dayjs";
import InvoiceSettledView from "./InvoiceSettled";

const ViewBid = ({ bidToView, isApproverView, userGroups, getDealBids, getAllLiveDeals, setShowBidViewModal }) => { //hasAcceptedBid
    console.log("user Groups", userGroups, bidToView)
  const printRef = useRef();
  const bidPreviewRef = useRef();
  const [showPreview, setShowPreview] = React.useState(false);
  const [showApproveSelection, setShowApproveSelection] = React.useState(false);
  const [reCallBidConfirmation, setReCallBidConfirmation] = React.useState(false)
  const [isUserApprover, setIsUserApprover] = React.useState(false)
  const [updatedBidStatus, setUpdatedBidStatus] = React.useState(null)
  const [updatedBidComments, setUpdatedBidComments] = React.useState(null)
  const [existingComments, setExistingComments] = React.useState(bidToView?.comments || [])

  const [approverList, setApproverList] = React.useState([]);
  const [selectedApproverList, setSelectedApproverList] = React.useState([]);

  const [invoicePreview, setInvoicePreview] = React.useState(null);
  const [settledINvoicePreview, setSettledInvoicePreview] = React.useState(null);
  const [nextInvoicePreview, setNextInvoicePreview] = React.useState(false)
  const [selectedPaymentTermForInvoice, setSelectedPaymentTermForInvoice] = React.useState(null)
  const [paymentDate, setPaymentDate] = React.useState(bidToView.paymentDate);
  const [payment1Date, setPayment1Date] = React.useState(bidToView.paymentTerms.length >= 1 ? bidToView.paymentTerms[0].date : null)
  const [payment2Date, setPayment2Date] = React.useState(bidToView.paymentTerms.length >= 2 ? bidToView.paymentTerms[1].date : null)
  const [paymentDateExists, setPaymentDateExists] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false);
  const [approveLoading, setApproveLoading] = React.useState(false);

  useEffect(()=>{
    userGroups.filter((grps)=>{
      let permissions = JSON.parse(grps.permissions)
      if (permissions?.bidApprover && permissions?.bidApprover === "yes"){
        setIsUserApprover(true)
      }
      
    })
  },[])

  const handleUpdateBidStatus = async ()=>{
    try{
      setApproveLoading(true)
        let pdfBlob = null;
        // if (updatedBidStatus === "APPROVED") {
        //   pdfBlob = await bidPreviewRef.current.generateBlob();
        // }

        let response = await BreathAPIs.updateBidStatus(
          bidToView._id,
          updatedBidStatus,
          updatedBidComments ? [...bidToView.comments, updatedBidComments] : bidToView.comments,
          bidToView.dealId?._id,
          
        );
        // pdfBlob
        if(response.status === 200){
            toast.success("Bid status updated successfully");
            getAllLiveDeals(isApproverView)
            setShowBidViewModal(false)
        }
    }catch(error){
        console.log("error in bid create api callj", error);
        toast.error("Error in updating bid status");
    }finally{
      setApproveLoading(false)
    }
  }

  const handleRecallBid = async () => {
    try {
      await handleUpdateBidStatus()
      getDealBids(bidToView.dealId._id)
      setShowBidViewModal(false)
    } catch (error) {
      console.log("error in bid create api callj", error);
      toast.error("Error in recalling bid");
    } finally {
      setReCallBidConfirmation(false);
    }
  }

  const sendBidForApproval = async () => {
    try {
      let response = await BreathAPIs.sendBidForApproval(
        bidToView._id,
        selectedApproverList
      );
      console.log("response for bid approve request: ", response);
      if (response.status === 200) {
        toast.success("bid send for approval");
        getDealBids(bidToView.dealId._id)
        setShowBidViewModal(false)
      }
    } catch (error) {
      console.log("error in bid create api callj", error);
      toast.error("Error in sending bid for approval");
    } finally {
      setShowApproveSelection(false);
    }
  };

  const getApproverList = async () => {
    let response = await BreathAPIs.getBidApproverList();
    if (response.status !== 200) {
      console.log("Error in fetching approver list");
      toast.error("Error in fetching approver list");
    } else {
      console.log("Approver List: ", response.data.approverList);
      setApproverList(response.data.approverList);
      setSelectedApproverList(response.data.approverList.map((approver) => approver._id))
    }
  };
  const updatePaymentDate = async (paymentOrder) => {
    try {
      setIsLoading(true)
      let response = await BreathAPIs.updatePaymentDate(bidToView._id, paymentOrder === "payment1" ? payment1Date : payment2Date);
      if (response.status === 200) {
        toast.success("Payment date updated successfully");
        // setPaymentDate(null)
        paymentOrder === "payment1" ? setPayment1Date(null) : setPayment2Date(null)
        window.location.reload();
      }
    } catch (error) {
      console.log("error in updating payment date", error);
      toast.error("Error in updating payment date");
    }
    finally{
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getApproverList();
  }, []);

  const newBidData = bidToView;

  const rows = [];

  // predefined fields
  const addRow = (data) => {
    if (data?.quantity) {
      rows.push(
        <tr key={data.title}>
          <td>
            <b>{data.title}</b> <br></br>
            {data.description}
          </td>
          <td className={styles['table-items-right']}>$ {(((data.pricePerUnit * data.quantity) + data.margin) / data.quantity).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          <td className={styles['table-items-right']}>{data.quantity}</td>
          <td className={styles['table-items-right']}>
                {`$ ${((data.quantity * data.pricePerUnit) + data.margin).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              {/* {(data.quantity * data.pricePerUnit) + data.margin} */}
              </td>
        </tr>
      );
    }
  };
  const lineItems = [
  newBidData?.l2Charger,
  newBidData?.l3Charger,
  newBidData?.electricalWork,
  newBidData?.wifiConnectivity,
  newBidData?.wifiAntenna,
  newBidData?.warranty,
  newBidData?.signage,
  newBidData?.pedestals,
  newBidData?.simCard4G,
  newBidData?.siteWiFi,
  newBidData?.chargerInstallOnly,
  newBidData?.shipping
].filter(item => item?.quantity);



if (newBidData?.bidCustomData?.length > 0) {
  newBidData.bidCustomData.forEach((item) => {
    if (item?.fieldQuantity) {
      lineItems.push({
        title: item.fieldTitle || "Custom Item",
        description: item.fieldDescription,
        pricePerUnit: item.fieldPricePerUnit,
        quantity: item.fieldQuantity,
        margin: item.fieldMargin,
        orderNumber: item.orderNumber || 0 // Ensure custom fields have an orderNumber
      });
    }
  });
}

lineItems.sort((a, b) => (a.orderNumber || 0) - (b.orderNumber || 0));

lineItems.forEach((data, index) => {
  rows.push(
    <tr key={data.title + index}>
      <td>
        <b>{data.title}</b> <br />
        {data.description}
      </td>
      <td className={styles['table-items-right']}>
        $ {(((data.pricePerUnit * data.quantity) + data.margin) / data.quantity)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </td>
      <td className={styles['table-items-right']}>{data.quantity}</td>
      <td className={styles['table-items-right']}>
        $ {((data.quantity * data.pricePerUnit) + data.margin)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </td>
    </tr>
  );
});

  // addRow(newBidData?.l2Charger);
  // addRow(newBidData?.l3Charger);
  // addRow(newBidData?.electricalWork);
  // addRow(newBidData?.wifiConnectivity);
  // addRow(newBidData?.wifiAntenna);
  // addRow(newBidData?.warranty);
  // addRow(newBidData?.signage);
  // addRow(newBidData?.pedestals);
  // addRow(newBidData?.simCard4G);
  //   addRow(newBidData?.siteWiFi);
  //   addRow(newBidData?.chargerInstallOnly);

  // // custom fields
  // if (newBidData?.bidCustomData?.length > 0) {
  //   newBidData.bidCustomData.forEach((item, index) => {
  //     if (item?.fieldQuantity) {
  //       rows.push(
  //         <tr key={`custom-${index}`}>
  //           <td>
  //             <b>{item.fieldTitle || "Custom Item"}</b>
  //             <br></br>
  //             {item.fieldDescription}
  //           </td>
  //           <td className={styles['table-items-right']}>$ {(((item.fieldPricePerUnit * item.fieldQuantity) + item.fieldMargin) / item.fieldQuantity).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
  //           <td className={styles['table-items-right']}>{item.fieldQuantity}</td>
  //           <td className={styles['table-items-right']}>$ {((item.fieldQuantity * item.fieldPricePerUnit) + item.fieldMargin).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
  //         </tr>
  //       );
  //     }
  //   });
  // }
  
  // addRow(newBidData?.shipping);

  let bidStatusClass = "";
  if (bidToView.bidStatus === "DRAFT") {
    bidStatusClass = "draft-status";
  } else if (bidToView.bidStatus === "PENDINGAPPROVAL") {
    bidStatusClass = "pending-approval-status";
  } else if (bidToView.bidStatus === "APPROVED") {
    bidStatusClass = "approved-status";
  } else if (bidToView.bidStatus === "REJECTED") {
    bidStatusClass = "rejected-status";
  }

  const downloadSampleProposal = async () =>{
    try{
      const blob = await bidPreviewRef.current.generateBlob({ watermark: true });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Proposal-${bidToView.bidNumber}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }catch(error){
      console.log("error downloading sample proposal: ", error);
    }
  }

  const handleAcceptBid = async (checked) =>{
    try{
      setIsLoading(true)
      let response = await BreathAPIs.acceptBid(bidToView._id, checked);
      if (response.status === 200) {
        toast.success("Bid accepted successfully");
        getDealBids(bidToView.dealId._id)
        setShowBidViewModal(false)
      }
    }catch(error){
      console.log("error accepting bid: ", error);
      toast.error("Error in accepting bid");
    }
    finally{
      setIsLoading(false)
    }
  }
  return (
    <div ref={printRef}>
      <div className={styles["view-bid-header-section"]}>
        <div>
          Date: <b>{new Date(bidToView.dateCreated).toLocaleDateString()}</b>
          <br></br>
          Proposal Number: <b>{bidToView.bidNumber}</b>
        </div>
        <div className={styles["view-bid-header=section-adress"]}>
          <b>
            {bidToView.dealId?.dealname}
            <br></br>
            {
              bidToView.dealPOC ?
                <>
                  {bidToView.dealPOC.name} <br></br>
                  {bidToView.dealPOC.email} <br></br>
                  {bidToView.dealPOC.phone}
                </> :
                bidToView.dealId?.property_address
            }
          </b>
        </div>
      </div>

      <p>
        Status:{" "}
        <span className={styles[bidStatusClass]}>
          <b>{bidToView.bidStatus}</b>
        </span>
      </p>

      <p>
        Owner: <b>{bidToView.dealId.owner}</b>
      </p>
      <p>
        Created By: <b>{bidToView.email}</b>
      </p>

      <table
        border="1"
        cellPadding="6"
        className={styles["table"]}
        // style={{ borderCollapse: "collapse", width: "100%" }}
      >
        <thead>
          <tr>
            <th>ITEMS & DESCRIPTION</th>
            <th>RATE/UNIT</th>
            <th>QTY</th>
            <th>AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows
          ) : (
            <tr>
              <td colSpan="4">No items available</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className={styles["view-bid-amount-section"]}>
        <p>
          SubTotal:{" "}
          <span className={styles["view-bids-amount-values"]}>
            $ {bidToView.subTotal ? bidToView.subTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}
          </span>
        </p>
        <p>
          {`SALES TAX (${bidToView.salesTaxPercent ? `${!Number.isInteger(bidToView.salesTaxPercent) ? Number(bidToView.salesTaxPercent).toFixed(2) : bidToView.salesTaxPercent}%` : '$' }):`}{" "}
          <span className={styles["view-bids-amount-values"]}>
            {" "}
            $ {bidToView.salesTax ? bidToView.salesTax.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}
          </span>
        </p>
        {bidToView.rebateTitle && <p>
          {bidToView.rebateTitle}:{" "}
          <span className={styles["view-bids-amount-values"]}>
            {" "}
            $ {bidToView.rebateAmount ? bidToView.rebateAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}
          </span>
        </p>}
        <p>
          Total Cost:{" "}
          <span className={styles["view-bids-amount-values"]}>
            $ {bidToView.totalCost ? bidToView.totalCost.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}
          </span>
        </p>
        <p>
          Total Margin:{" "}
          <span className={styles["view-bids-amount-values"]}>
            $ {bidToView.totalMargin ? bidToView.totalMargin.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}
          </span>
        </p>
      </div>

       <p><b>Description:</b> <br></br>{bidToView.customDescription}</p>

      <p><b>Terms and Conditions:</b> <br></br>{bidToView.termsAndConditions}</p>
      <p><b>Payment Type: </b> <span style={{background: "yellow"}}>{bidToView.paymentType.split(/(?=[A-Z])/)[0] + " " + bidToView.paymentType.split(/(?=[A-Z])/)[1]}</span></p>

      {
        bidToView?.comments && bidToView?.comments.length > 0 &&
        <p><b>Comments:</b>

          {bidToView.comments.map((comment, index) => (
            <div key={index}>
              <br></br>
              <p style={{ margin: '0' }}>{index+1}.{comment}</p>
            </div>
          ))}

        </p>
      }
{console.log("Is bid acepcted-----",bidToView.dealId.dealstage)}
{
  bidToView.bidStatus === "APPROVED" && (bidToView.dealId.dealstage === "Pending Bid" || 
                                          bidToView.dealId.dealstage === "Bid Sent" ||
                                          bidToView.dealId.dealstage === "Pending Bid Review" || 
                                          bidToView.dealId.dealstage === "Bid Review Complete") &&
        <Checkbox onChange={(e) => handleAcceptBid(e.target.checked)}
          checked={bidToView.acceptedProposal}
          // disabled={hasAcceptedBid && !bidToView.acceptedProposal}
          >
          Accepted by client 
        </Checkbox>
      }
      

      {
        bidToView.bidStatus === "PENDINGAPPROVAL" && isUserApprover && isApproverView &&
        <div>
            <Select
              showSearch
              placeholder="Approve Proposal"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
              value={updatedBidStatus}
              onChange={(value) => setUpdatedBidStatus(value)}
            >
              <Select.Option value="APPROVED" key="APPROVED">
                Approve
              </Select.Option>
              <Select.Option value="REJECTED" key="REJECTED">
                Reject
              </Select.Option>
            </Select>

            <Form.Item  label="Comments">
            <Input.TextArea 
            required={updatedBidStatus === "REJECTED" ? true : false}
            value={ updatedBidComments } 
            onChange={(e) => {
              setUpdatedBidComments(e.target.value)
            }}
            />
          </Form.Item>
            <div className={styles['approver-view-bid-button-cntr']}>
              <Button disabled={!updatedBidStatus || approveLoading} onClick={() => handleUpdateBidStatus()} className={styles['view-bid-btn']}>
                {approveLoading ? "Forwarding..." : "Forward Proposal"}
              </Button>
              <Button onClick={() => downloadSampleProposal()} className={styles['view-bid-btn']}>
                Download Sample Proposal
              </Button>
            </div>


          </div>
      }

      <div className={styles['view-bid-button-cntr']}>
        <button onClick={() => setShowPreview(!showPreview)} className={styles['view-bid-btn']}>
          Preview Proposal
        </button>
        {
          ((bidToView.bidStatus === "DRAFT" || bidToView.bidStatus === "REJECTED") && bidToView.dealId.dealstage === "Pending Bid") &&
          <button onClick={() => { setShowApproveSelection(true) }} className={styles['view-bid-btn']}>
            Send for Approval
          </button>
        }
        {
          (bidToView.bidStatus === "PENDINGAPPROVAL") &&
          <button 
          onClick={() => { setReCallBidConfirmation(true); setUpdatedBidStatus("DRAFT") }}
           className={styles['view-bid-btn']}>
            Recall Bid
          </button>
        }
        {
            (bidToView.bidStatus === "APPROVED") &&
            <button onClick={() => { setInvoicePreview(true); setSelectedPaymentTermForInvoice(bidToView.paymentType === 'PartPayment' ? 1 : null) }} className={styles['view-bid-btn']}>
            Preview Invoice
          </button>
        }
        {/* {
            (bidToView.bidStatus === "APPROVED") && (bidToView.paymentDate && bidToView.paymentDate !== null) &&
            <button onClick={() => { setSettledInvoicePreview(true) }} className={styles['view-bid-btn']}>
            Preview Settled Invoice
          </button>
        } */}

      </div>
      <div className={styles['invoice-patyment-date']}>
        <div>
          <span>{ bidToView.paymentType === "FullPayment" ?  `Payment Recieved on:` :  `Payment 1 Recieved on:`}</span>
          <DatePicker
          value={payment1Date ? dayjs(payment1Date) : null}
            onChange={(date) => {
              setPayment1Date(date ? new Date(date.$d) : null);
              setPaymentDateExists(true)
            }}
            disabled={(!(bidToView.bidStatus === "APPROVED" && (bidToView.dealId?.dealstage !== "Bid Sent" && bidToView.dealId?.dealstage !== "Pending Bid"))) || (bidToView.paymentTerms.length >= 1)}
          >
          </DatePicker>
        </div>
        {
            (bidToView.bidStatus === "APPROVED") && (bidToView.paymentTerms.length >=1) &&
            <button onClick={() => { setSettledInvoicePreview(true); setSelectedPaymentTermForInvoice(1) }} className={styles['view-bid-btn']}>
            Preview Settled Invoice
          </button>
        }
        {
            (bidToView.bidStatus === "APPROVED") && (bidToView.paymentTerms.length >=1) && bidToView.paymentType === "PartPayment" && 
            <button onClick={() => { setNextInvoicePreview(true); setSelectedPaymentTermForInvoice(2) }} className={styles['view-bid-btn']}>
            Preview Next Payment Invoice
          </button>
        }
        {
        <button
          disabled={(!paymentDateExists  ? true : false) || isLoading}
          onClick={() => {
            updatePaymentDate("payment1")
          }}
          >
          {isLoading ? "Updating" : (bidToView.paymentType === "FullPayment" ? "Update Payment Date" : "Update Payment 1 Date")}
        </button>
        }
      </div>
      {
        bidToView?.paymentType === "PartPayment" && 
        <div className={styles['invoice-patyment-date']}>
        <div>
          <span>{ `Payment 2 Recieved on:`}</span>
          <DatePicker
          value={payment2Date ? dayjs(payment2Date) : null}
            onChange={(date) => {
              setPayment2Date(date ? new Date(date.$d) : null);
              setPaymentDateExists(true)
            }}
            disabled={(!(bidToView.bidStatus === "APPROVED" && (bidToView.dealId?.dealstage !== "Bid Sent" && bidToView.dealId?.dealstage !== "Pending Bid") && (bidToView?.paymentTerms?.length > 0))) || (bidToView.paymentTerms.length >= 2)  }
          >
          </DatePicker>
        </div>
        {
            (bidToView.bidStatus === "APPROVED") && (bidToView.paymentTerms.length >=2) &&
            <button onClick={() => { setSettledInvoicePreview(true); setSelectedPaymentTermForInvoice(2) }} className={styles['view-bid-btn']}>
            Preview Settled Invoice
          </button>
        }
        {
        <button
          disabled={(!paymentDateExists  ? true : false) || isLoading}
          onClick={() => {
            updatePaymentDate("payment2")
          }}
          >
          {isLoading ? "Updating" : "Update Payment 2 Date"}
        </button>
        }
      </div>
      }

      {
        invoicePreview &&
        <Drawer
          title={`INVOICE-${bidToView.bidNumber}`}
          placement="bottom"
          closable={true}
          onClose={()=>{setInvoicePreview(false)}}
          open={invoicePreview}
          // getContainer={false}
          height={'85%'}
          
          
        >
            <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
          <InvoiceView bidData={bidToView} selectedPaymentTermForInvoice={selectedPaymentTermForInvoice}></InvoiceView>
          </div>
        </Drawer>
        // <Modal open={invoicePreview} onCancel={()=>{setInvoicePreview(false)}} footer={null} centered width={"1000px"}>
        //     <InvoiceView bidData={bidToView}></InvoiceView>
        // </Modal>
      }
      {console.log("settledINvoicePreview",settledINvoicePreview)}
      {
        settledINvoicePreview &&
        <Drawer
          title={`INVOICE-${bidToView.bidNumber}`}
          placement="bottom"
          closable={true}
          onClose={()=>{setSettledInvoicePreview(false)}}
          open={settledINvoicePreview}
          // getContainer={false}
          height={'85%'}
          
          
        >
            <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
          {/* {(bidToView.paymentType === "PartPayment" &&  selectedPaymentTermForInvoice == 1) ? <InvoiceView bidData={bidToView} selectedPaymentTermForInvoice={selectedPaymentTermForInvoice}></InvoiceView> :   */}
          <InvoiceSettledView bidData={bidToView} selectedPaymentTermForInvoice={selectedPaymentTermForInvoice}></InvoiceSettledView>
          {/* } */}

          </div>
        </Drawer>
        // <Modal open={invoicePreview} onCancel={()=>{setInvoicePreview(false)}} footer={null} centered width={"1000px"}>
        //     <InvoiceView bidData={bidToView}></InvoiceView>
        // </Modal>
      }
      {
        nextInvoicePreview &&
        <Drawer
          title={`INVOICE-${bidToView.bidNumber}`}
          placement="bottom"
          closable={true}
          onClose={()=>{setNextInvoicePreview(false)}}
          open={nextInvoicePreview}
          // getContainer={false}
          height={'85%'}
          
          
        >
            <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
          {/* {(bidToView.paymentType === "PartPayment" &&  selectedPaymentTermForInvoice == 1) ?  */}
          <InvoiceView bidData={bidToView} selectedPaymentTermForInvoice={selectedPaymentTermForInvoice}></InvoiceView> :  
          {/* <InvoiceSettledView bidData={bidToView} selectedPaymentTermForInvoice={selectedPaymentTermForInvoice}></InvoiceSettledView> */}
          {/* } */}

          </div>
        </Drawer>
        // <Modal open={invoicePreview} onCancel={()=>{setInvoicePreview(false)}} footer={null} centered width={"1000px"}>
        //     <InvoiceView bidData={bidToView}></InvoiceView>
        // </Modal>
      }
      
      {/* Hidden BidPreview for PDF generation on approval */}
      <div style={{ position: "absolute", left: "-9999px", top: 0, pointerEvents: "none" }}>
        <BidPreview ref={bidPreviewRef} bidToView={bidToView} />
      </div>

      {showPreview && (
        <Drawer
        title={`PROPOSAL-${bidToView.bidNumber}`}
          open={showPreview}
          placement="bottom"
          closable={true}
          onClose={() => {
            setShowPreview(false);
          }}
          height={"90%"}
        >
            <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                <BidPreview bidToView={bidToView}></BidPreview>
            </div>
        </Drawer>
      )}

      {
        reCallBidConfirmation && (
          <Modal
            open={reCallBidConfirmation}
            onCancel={() => {setReCallBidConfirmation(false); setUpdatedBidStatus(null)}}
            footer={null}
            centered
          >
            <div>
              <h6>Proposal Number: {bidToView.bidNumber}</h6>
              <p>Are you sure you want to recall this bid?</p>
              <Button onClick={() => {setReCallBidConfirmation(false); setUpdatedBidStatus(null)}}>Cancel</Button>
              <Button onClick={() => handleRecallBid()}>Recall</Button>
            </div>
          </Modal>
        )
      }

      {showApproveSelection && (
        <Modal
          open={showApproveSelection}
          onCancel={() => setShowApproveSelection(false)}
          footer={null}
          centered
        >
          <div>
            <h6>Proposal Number: {bidToView.bidNumber}</h6>
            <Select
              showSearch
              placeholder="Select an approver"
              optionFilterProp="children"
              mode="multiple"
              value={selectedApproverList}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
              onChange={(values) => setSelectedApproverList(values)}
            >
              {approverList.map((approver) => (
                <Select.Option on key={approver._id} value={approver._id}>
                  {approver.firstName} {approver.lastName}
                </Select.Option>
              ))}
            </Select>
            <Button
              className={styles["custom-button"]}
              style={{ marginTop: "20px" }}
              type="button"
              onClick={() => {
                sendBidForApproval();
              }}
            >
              Send for Approval
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

// export default ViewBid;


ViewBid.propTypes = {
  user: PropTypes.string,
  userID: PropTypes.string,
  userGroups: PropTypes.array,
  phone: PropTypes.string
}
const mapStateToProps = state => ({
  user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
  phone: state.auth && state.auth.user ? state.auth.user.phone : false
})
export default connect(mapStateToProps,{})(ViewBid);